<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>      
      <router-view v-if="$route.meta.keepAlive"/>    
    </keep-alive>    
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: 'Microsoft YaHei';
}
a,
button,
input {
  outline: none;
}
* {
  margin: 0;
  padding: 0;
}
.padding-top{
  padding-top: 1.2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue